import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const MapLocations = () => {
    //#region const
    const navigate = useNavigate();
    const toaster = useToaster();
    const [ShowModal, setShowModal] = useState(false);
    const [Title, setTitle] = useState("");
    const [Address, setAddress] = useState("");
    const [Lat, setLat] = useState(29.6);
    const [Lng, setLng] = useState(52.53);
    const [IsActive, setIsActive] = useState(true);
    const [Order, setOrder] = useState(0);
    const [LocationId, setLocationId] = useState(General.GuidEmpty());
    const [Locations, setLocations] = useState([]);
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region method
    const clearDependecies = () => {
        setLocationId(General.GuidEmpty());
        setTitle("");
        setAddress("");
        setLat(29.6);
        setLng(52.53);
        setIsActive(true);
        setOrder(0);
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/mapLocation/delete/' + LocationId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetLocations();
                    setLocationId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetLocationById = (Id) => {
        setLocationId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/mapLocation/getById/' + Id,
            method: "get",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setAddress(row.Address);
                        setLat(row.Lat);
                        setLng(row.Lng);
                        setIsActive(!!row.IsActive);
                        setOrder(row.Order);
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetLocations = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/mapLocation/getAll',
            method: "get",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setLocations(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const AddNewLocation = () => {
        setShowModal(true);
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else if (Address == "") {
            setErrorMsg('لطفا آدرس را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا آدرس را وارد کنید'), 'topCenter');
            return false;
        }
        else if (Lat === "" || Lng === "") {
            setErrorMsg('لطفا مختصات جغرافیایی را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا مختصات جغرافیایی را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = LocationId === General.GuidEmpty();
            const requestOptions = {
                url: General.ApiRoot() + '/mapLocation/' + (isNew ? 'insert' : 'update'),
                method: "post",
                data: { Id: LocationId, Title, Address, Lat, Lng, IsActive: IsActive ? 1 : 0, Order },
                headers: {
                    'Content-Type': 'application/json',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetLocations();
                        clearDependecies();
                        setShowModal(false);
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    //#endregion

    const columns = [
        {
            id: "title",
            header: () => <div className="text-right">عنوان</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "address",
            header: () => <div className="text-right">آدرس</div>,
            cell: ({ row }) => <div className="">{row.original.Address}</div>,
        },
        {
            id: "coords",
            header: () => <div className="text-right">مختصات</div>,
            cell: ({ row }) => <div className="">{row.original.Lat}, {row.original.Lng}</div>,
        },
        {
            id: "isActive",
            header: () => <div className="text-right">وضعیت</div>,
            cell: ({ row }) => <div className="">{row.original.IsActive ? "فعال" : "غیرفعال"}</div>,
        },
        General.actionsColumn(GetLocationById, (id) => (setLocationId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Locations,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        if (!General.isLoggedIn()) {
            navigate('/');
        }
        else {
            GetLocations();
        }
    }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="موقعیت‌های نقشه" onAdd={AddNewLocation} />
                <DataTable table={table} />
            </div>

            <CrudFormModal
                open={ShowModal}
                title="تعریف موقعیت جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Row>
                    <rsuite.Col xs={12}>
                        <label>عنوان (مثلا دفتر مرکزی)</label>
                        <rsuite.Input value={Title} onChange={e => setTitle(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>ترتیب نمایش</label>
                        <rsuite.InputNumber value={Order} onChange={e => setOrder(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row>
                    <label>آدرس</label>
                    <rsuite.Input as="textarea" value={Address} onChange={e => setAddress(e)} rows={2} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <rsuite.Col xs={12}>
                        <label>عرض جغرافیایی (Lat)</label>
                        <rsuite.InputNumber step={0.0000001} value={Lat} onChange={e => setLat(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                    <rsuite.Col xs={12}>
                        <label>طول جغرافیایی (Lng)</label>
                        <rsuite.InputNumber step={0.0000001} value={Lng} onChange={e => setLng(e)} className="mt-1 mb-3" />
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row>
                    <rsuite.Col xs={24}>
                        <rsuite.Checkbox checked={IsActive} onChange={() => setIsActive(!IsActive)}>روی نقشه نمایش داده شود</rsuite.Checkbox>
                    </rsuite.Col>
                </rsuite.Row>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف این موقعیت مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setLocationId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default MapLocations;
